import { SEVERITY } from "helpers/utils.js";
import {
  GET_ITEM_UNIT_OF_MEASUREMENTS,
  GET_ITEM_UNIT_OF_MEASUREMENTS_SUCCESS,
  GET_ITEM_UNIT_OF_MEASUREMENT_BY_ID_SUCCESS,
  GET_ITEM_UNIT_OF_MEASUREMENTS_ERROR,
  ITEM_UNIT_OF_MEASUREMENT_CLEAR_ERROR,
  GET_ITEM_UNIT_OF_MEASUREMENT_BY_ID,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  totalAmount: 0,
  totalUom: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const Category = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ITEM_UNIT_OF_MEASUREMENTS:
      return {
        ...state,
        loading: true,
      };
    case GET_ITEM_UNIT_OF_MEASUREMENTS_SUCCESS:
      const { itemCount, pageCount, totalAmount, totalUom, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        totalAmount,
        totalUom,
        items: data,
        item: null,
        loading: false,
      };
    case GET_ITEM_UNIT_OF_MEASUREMENT_BY_ID:
      return {
        ...state,
        item: null,
      };
    case GET_ITEM_UNIT_OF_MEASUREMENT_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_ITEM_UNIT_OF_MEASUREMENTS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_ItemUnitOfMeasurement");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Unit of Measurement already exist." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case ITEM_UNIT_OF_MEASUREMENT_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default Category;
